import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
const baseURL =
  process.env.NODE_ENV === "production"
    ? "http://invoiceplus.net/api/"
    : "http://localhost/api.invoice/";
axios.defaults.baseURL = baseURL;
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    status: "",
    token: localStorage.getItem("token") || "",
    user: {},
    base_url:
      process.env.NODE_ENV === "production"
        ? "http://invoiceplus.net/api/"
        : "http://localhost/api.invoice/",
    isLoading: false,
    activeBtn: null
  },

  mutations: {
    auth_request(state) {
      state.status = "loading";
    },
    auth_success(state, token) {
      state.status = "success";
      state.token = token;
    },
    auth_error(state) {
      state.status = "error";
    },
    logout(state) {
      state.status = "";
      state.token = "";
    }
  },

  actions: {
    authRequest({ commit }, dataParams) {
      return new Promise((resolve, reject) => {
        commit("auth_request");
        axios({
          url: dataParams.url,
          data: dataParams.formData,
          method: "POST"
        })
          .then(resp => {
            const token = resp.data.token;
            if (token) {
              localStorage.setItem("token", token);
              axios.defaults.headers.common["Authorization"] = token;
              commit("auth_success", token);
            }

            resolve(resp);
          })
          .catch(err => {
            commit("auth_error");
            localStorage.removeItem("token");
            reject(err);
          });
      });
    },

    logUser({ commit }, user) {
      return new Promise((resolve, reject) => {
        commit("auth_request");
        axios
          .post("ap/log-user/", user)
          .then(resp => {
            const token = resp.data.token;
            if (token) {
              localStorage.setItem("token", token);
              axios.defaults.headers.common["Authorization"] = token;
              commit("auth_success", token);
            }
            resolve(resp);
          })
          .catch(err => {
            commit("auth_error");
            localStorage.removeItem("token");
            reject(err);
          });
      });
    },

    logAdmin({ commit }, user) {
      return new Promise((resolve, reject) => {
        commit("auth_request");
        axios
          .post("duka-root/authenticate/", user)
          .then(resp => {
            const token = resp.data.token;
            localStorage.setItem("token", token);
            axios.defaults.headers.common["Authorization"] = token;
            commit("auth_success", token);
            resolve(resp);
          })
          .catch(err => {
            commit("auth_error");
            localStorage.removeItem("token");
            reject(err);
          });
      });
    },

    logout({ commit }) {
      return new Promise(resolve => {
        commit("logout");
        localStorage.removeItem("token");
        delete axios.defaults.headers.common["Authorization"];
        resolve();
      });
    },

    dukaPostRequest({ commit }, dataParams) {
      return new Promise((resolve, reject) => {
        commit("auth_request");
        const token = localStorage.getItem("token");
        if (token) {
          dataParams.formData.append("token", token);
        }
        axios
          .post(dataParams.url, dataParams.formData)
          .then(resp => {
            if (resp.data.unauthorized) {
              this.dispatch("logout").then(() => {
                window.location.replace("/");
              });
            }
            commit("auth_success");
            resolve(resp);
          })
          .catch(err => {
            commit("auth_error");
            reject(err);
          });
      });
    },

    dukaGetRequest({ commit }, getURL) {
      return new Promise((resolve, reject) => {
        commit("auth_request");
        const token = localStorage.getItem("token");
        var fd = new FormData();
        if (token) {
          fd.append("token", token);
        }
        axios
          .post(getURL, fd)
          .then(resp => {
            if (resp.data.unauthorized) {
              this.dispatch("logout").then(() => {
                window.location.replace("/");
              });
            }
            resolve(resp);
          })
          .catch(err => {
            commit("auth_error");
            reject(err);
          });
      });
    }
  },
  getters: {
    isLoggedIn: state => !!state.token,
    authStatus: state => state.status
  }
});
